// extracted by mini-css-extract-plugin
export default {"container":"banner_container__GSuYW","search-container":"banner_search-container__FhEwu","indicator":"banner_indicator__J8xTQ"};